export const inputStyles = {
  base: 'block w-full rounded-xl border border-[color:var(--wf-border)] bg-[color:var(--wf-paper)] px-4 py-3 text-[color:var(--wf-ink)] placeholder-[#9a8978] shadow-sm transition-all duration-200 focus:border-[color:var(--wf-brass)] focus:outline-none focus:ring-2 focus:ring-[color:var(--wf-plum)]/20 sm:text-sm',
  error: 'border-red-300 focus:border-red-500 focus:ring-red-500/20'
};

export const buttonStyles = {
  base: 'rounded-xl font-medium tracking-[0.03em] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  variants: {
    primary: 'border border-[color:var(--wf-plum-deep)]/60 bg-[linear-gradient(135deg,rgba(67,48,63,1),rgba(95,70,92,1))] text-[#f8f2ea] shadow-[0_10px_30px_rgba(67,48,63,0.18)] hover:-translate-y-0.5 hover:shadow-[0_16px_36px_rgba(67,48,63,0.24)] focus:ring-[color:var(--wf-plum)]',
    secondary: 'border border-[color:var(--wf-border-strong)] bg-[linear-gradient(135deg,rgba(251,246,238,0.96),rgba(243,233,218,0.98))] text-[color:var(--wf-ink)] hover:border-[color:var(--wf-brass)] hover:bg-[linear-gradient(135deg,rgba(251,246,238,1),rgba(239,225,207,0.98))] focus:ring-[color:var(--wf-brass)]',
    danger: 'bg-[color:var(--wf-error)] text-white hover:bg-[#8c3f39] focus:ring-red-500'
  }
};

export const pageStyles = {
  container: 'flex min-h-[60vh] flex-col items-center justify-center px-4',
  title: 'font-serif text-3xl text-[color:var(--wf-ink)]'
};
